const application = {
  // Page Title
  pageTitle: 'تقديم طلب الالتحاق',
  pageSubtitle: 'انضم إلى كلية ساي لتعليم اللغة الصينية',
  
  // Progress Steps
  steps: {
    personal: 'البيانات الشخصية',
    contact: 'معلومات الاتصال',
    academic: 'المعلومات الأكاديمية',
    documents: 'المستندات المطلوبة',
    motivation: 'الدافع والأهداف',
    review: 'المراجعة والإرسال'
  },
  
  // Personal Information
  personal: {
    title: 'البيانات الشخصية',
    subtitle: 'الرجاء إدخال بياناتك الشخصية بدقة',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'أدخل اسمك الكامل',
    fullNameEn: 'الاسم بالإنجليزية',
    fullNameEnPlaceholder: 'أدخل اسمك بالإنجليزية',
    dateOfBirth: 'تاريخ الميلاد',
    gender: 'الجنس',
    male: 'ذكر',
    female: 'أنثى',
    nationality: 'الجنسية',
    nationalityPlaceholder: 'اختر جنسيتك',
    idNumber: 'رقم الهوية/جواز السفر',
    idNumberPlaceholder: 'أدخل رقم الهوية أو جواز السفر',
    placeOfBirth: 'مكان الميلاد',
    placeOfBirthPlaceholder: 'أدخل مكان ميلادك'
  },
  
  // Contact Information
  contact: {
    title: 'معلومات الاتصال',
    subtitle: 'كيف يمكننا التواصل معك؟',
    phone: 'رقم الهاتف',
    phonePlaceholder: 'أدخل رقم هاتفك',
    whatsapp: 'رقم الواتساب',
    whatsappPlaceholder: 'أدخل رقم الواتساب',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'أدخل بريدك الإلكتروني',
    address: 'العنوان',
    addressPlaceholder: 'أدخل عنوانك الكامل',
    city: 'المدينة',
    cityPlaceholder: 'أدخل المدينة',
    emergencyContact: 'جهة الاتصال في حالات الطوارئ',
    emergencyContactPlaceholder: 'اسم ورقم هاتف',
    emergencyRelation: 'صلة القرابة',
    emergencyRelationPlaceholder: 'مثال: والد، أخ، صديق'
  },
  
  // Academic Information
  academic: {
    title: 'المعلومات الأكاديمية',
    subtitle: 'أخبرنا عن خلفيتك التعليمية',
    program: 'البرنامج المطلوب',
    programPlaceholder: 'اختر البرنامج',
    hsk1: 'HSK المستوى الأول',
    hsk2: 'HSK المستوى الثاني',
    hsk3: 'HSK المستوى الثالث',
    hsk4: 'HSK المستوى الرابع',
    hsk5: 'HSK المستوى الخامس',
    hsk6: 'HSK المستوى السادس',
    yct: 'YCT - اختبار اللغة الصينية للأطفال',
    businessChinese: 'اللغة الصينية للأعمال',
    educationLevel: 'المستوى التعليمي',
    educationLevelPlaceholder: 'اختر مستواك التعليمي',
    highSchool: 'ثانوية عامة',
    diploma: 'دبلوم',
    bachelor: 'بكالوريوس',
    master: 'ماجستير',
    doctorate: 'دكتوراه',
    previousSchool: 'المدرسة/الجامعة السابقة',
    previousSchoolPlaceholder: 'اسم المؤسسة التعليمية',
    gpa: 'المعدل التراكمي',
    gpaPlaceholder: 'أدخل معدلك التراكمي',
    chineseLevel: 'مستواك الحالي في اللغة الصينية',
    chineseLevelPlaceholder: 'اختر مستواك',
    beginner: 'مبتدئ',
    elementary: 'أساسي',
    intermediate: 'متوسط',
    advanced: 'متقدم',
    previousChinese: 'هل درست اللغة الصينية من قبل؟',
    yes: 'نعم',
    no: 'لا',
    previousDetails: 'تفاصيل الدراسة السابقة',
    previousDetailsPlaceholder: 'أين ومتى درست اللغة الصينية؟'
  },
  
  // Documents
  documents: {
    title: 'المستندات المطلوبة',
    subtitle: 'يرجى رفع المستندات التالية (PDF أو صور)',
    photo: 'الصورة الشخصية',
    photoDesc: 'صورة حديثة بخلفية بيضاء',
    idCopy: 'نسخة من الهوية/جواز السفر',
    idCopyDesc: 'نسخة واضحة من وثيقة الهوية',
    certificates: 'الشهادات الدراسية',
    certificatesDesc: 'آخر شهادة دراسية حصلت عليها',
    transcript: 'كشف الدرجات',
    transcriptDesc: 'كشف درجات آخر مرحلة دراسية',
    uploadButton: 'اختر ملف',
    changeButton: 'تغيير الملف',
    uploaded: 'تم الرفع',
    notUploaded: 'لم يتم الرفع',
    maxSize: 'الحد الأقصى: 5 ميجابايت',
    supportedFormats: 'الصيغ المدعومة: JPG, PNG, PDF'
  },
  
  // Motivation
  motivation: {
    title: 'الدافع والأهداف',
    subtitle: 'أخبرنا عن دوافعك وأهدافك',
    whyStudy: 'لماذا تريد دراسة اللغة الصينية؟',
    whyStudyPlaceholder: 'اشرح دوافعك لتعلم اللغة الصينية (150-500 حرف)',
    goals: 'ما هي أهدافك المستقبلية؟',
    goalsPlaceholder: 'ما الذي تأمل تحقيقه بعد إتقان اللغة الصينية؟ (150-500 حرف)',
    interests: 'اهتماماتك بالثقافة الصينية',
    interestsPlaceholder: 'ما الذي يثير اهتمامك في الثقافة الصينية؟',
    careerPlans: 'خططك المهنية',
    careerPlansPlaceholder: 'كيف ستساعدك اللغة الصينية في مسيرتك المهنية؟',
    charCount: 'عدد الأحرف'
  },
  
  // Review
  review: {
    title: 'مراجعة الطلب',
    subtitle: 'يرجى مراجعة جميع المعلومات قبل الإرسال',
    personalInfo: 'البيانات الشخصية',
    contactInfo: 'معلومات الاتصال',
    academicInfo: 'المعلومات الأكاديمية',
    documentsInfo: 'المستندات',
    motivationInfo: 'الدافع والأهداف',
    edit: 'تعديل',
    declaration: 'أقر بأن جميع المعلومات المقدمة صحيحة ودقيقة',
    terms: 'أوافق على الشروط والأحكام',
    viewTerms: 'عرض الشروط والأحكام'
  },
  
  // Success
  success: {
    title: 'تم إرسال طلبك بنجاح!',
    subtitle: 'شكراً لتقديم طلب الالتحاق بكلية ساي',
    applicationNumber: 'رقم الطلب',
    nextSteps: 'الخطوات التالية',
    step1: 'سيتم مراجعة طلبك خلال 3-5 أيام عمل',
    step2: 'سنتواصل معك عبر البريد الإلكتروني أو الهاتف',
    step3: 'قد يُطلب منك حضور مقابلة شخصية أو اختبار تحديد مستوى',
    step4: 'بعد القبول، ستتلقى خطاب القبول وتعليمات التسجيل',
    backHome: 'العودة للصفحة الرئيسية',
    viewCourses: 'تصفح الدورات',
    contactUs: 'تواصل معنا'
  },
  
  // Buttons
  buttons: {
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال الطلب',
    save: 'حفظ',
    cancel: 'إلغاء'
  },
  
  // Validation
  validation: {
    required: 'هذا الحقل مطلوب',
    invalidEmail: 'البريد الإلكتروني غير صحيح',
    invalidPhone: 'رقم الهاتف غير صحيح',
    minLength: 'يجب أن يحتوي على {min} حرف على الأقل',
    maxLength: 'يجب ألا يتجاوز {max} حرف',
    fileSize: 'حجم الملف يجب ألا يتجاوز 5 ميجابايت',
    fileType: 'نوع الملف غير مدعوم'
  }
};

export default application;